import script from "./paperResList.vue?vue&type=script&lang=ts&setup=true"
export * from "./paperResList.vue?vue&type=script&lang=ts&setup=true"

import "./paperResList.vue?vue&type=style&index=0&id=bea6f0e6&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bea6f0e6"]])

export default __exports__